$(document).ready(function(){
    $('variant-radios input').on('change',function(){
        setTimeout(() => {
            if($('.product-form__buttons button.product-form__submit').hasClass('restock-rocket-preorder-button')) {
                $('.product__inventory .shipping-badge').hide();
            } else {
                $('.product__inventory .shipping-badge').show();
            }
        }, 500);
        setTimeout(() => {
            if($('.product-form__buttons button.product-form__submit').hasClass('restock-rocket-preorder-button')) {
                $('.product__inventory .shipping-badge').hide();
            } else {
                $('.product__inventory .shipping-badge').show();
            }
        }, 1000);
        setTimeout(() => {
            if($('.product-form__buttons button.product-form__submit').hasClass('restock-rocket-preorder-button')) {
                $('.product__inventory .shipping-badge').hide();
            } else {
                $('.product__inventory .shipping-badge').show();
            }
        }, 2000);
    })
    setTimeout(() => {
        if($('.product-form__buttons button.product-form__submit').hasClass('restock-rocket-preorder-button')) {
            $('.product__inventory .shipping-badge').hide();
        } else {
            $('.product__inventory .shipping-badge').show();
        }
    }, 500);
    setTimeout(() => {
        if($('.product-form__buttons button.product-form__submit').hasClass('restock-rocket-preorder-button')) {
            $('.product__inventory .shipping-badge').hide();
        } else {
            $('.product__inventory .shipping-badge').show();
        }
    }, 1000);
    setTimeout(() => {
        if($('.product-form__buttons button.product-form__submit').hasClass('restock-rocket-preorder-button')) {
            $('.product__inventory .shipping-badge').hide();
        } else {
            $('.product__inventory .shipping-badge').show();
        }
    }, 2000);
    setTimeout(() => {
        if($('.product-form__buttons button.product-form__submit').hasClass('restock-rocket-preorder-button')) {
            $('.product__inventory .shipping-badge').hide();
        } else {
            $('.product__inventory .shipping-badge').show();
        }
    }, 3000);
})
